import { render, staticRenderFns } from "./MainBookCompCard2Print.vue?vue&type=template&id=971f0814&scoped=true"
import script from "./MainBookCompCard2Print.vue?vue&type=script&lang=js"
export * from "./MainBookCompCard2Print.vue?vue&type=script&lang=js"
import style0 from "./MainBookCompCard2Print.vue?vue&type=style&index=0&id=971f0814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971f0814",
  null
  
)

export default component.exports